import styled from 'styled-components';

const ImageContainer = styled.div`
  position: absolute;
  z-index: -999;
  inset: 0;
  width: 100%;
  height: 100%;

  background-image: url('https://assets.hbsuk.co.uk/img/platform/HBSUK_ConnectingLine_03_Comp.png');
  background-position: center;
  background-repeat: no-repeat;
  background-size: 120%;

  @media (max-width: 576px) {
    background-position: center 5%;
    pointer-events: none;
  }
`;

const BackgroundSwish = () => {
  return <ImageContainer />;
};

export default BackgroundSwish;
